/* ============================================================
 * AYU Cookie Disclaimer Banner
 * Analog zu MENTO – Bottom-Banner mit Akzeptieren/Ablehnen
 * ============================================================ */
import { useState, useEffect } from "react";
import { X } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("ayu-cookie-consent");
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("ayu-cookie-consent", "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("ayu-cookie-consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] transition-all duration-500"
      style={{
        transform: visible ? "translateY(0)" : "translateY(100%)",
        opacity: visible ? 1 : 0,
      }}
    >
      <div
        className="mx-4 mb-4 sm:mx-8 sm:mb-6 rounded-2xl shadow-2xl border overflow-hidden"
        style={{
          background: "oklch(0.18 0.02 280)",
          borderColor: "oklch(0.3 0.02 280)",
          backdropFilter: "blur(20px)",
        }}
      >
        <div className="p-5 sm:p-6">
          <div className="flex items-start gap-4">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-[oklch(0.78_0.11_85)] text-lg">🍪</span>
                <h3 className="text-base font-bold text-[oklch(0.95_0.01_80)]">
                  Wir verwenden Cookies
                </h3>
              </div>
              <p
                className="text-sm text-[oklch(0.65_0.01_80)] leading-relaxed max-w-2xl"
                style={{ fontFamily: "var(--font-body)" }}
              >
                Wir nutzen Cookies, um dir die bestmögliche Erfahrung auf unserer Website zu bieten.
                Einige sind notwendig, andere helfen uns, die Website zu verbessern.
                Mehr dazu in unserer{" "}
                <a
                  href="/datenschutz"
                  className="text-[oklch(0.52_0.09_128)] hover:underline"
                >
                  Datenschutzerklärung
                </a>.
              </p>
            </div>

            {/* Close button */}
            <button
              onClick={handleDecline}
              className="text-[oklch(0.5_0.01_80)] hover:text-[oklch(0.8_0.01_80)] transition-colors mt-1 shrink-0"
              aria-label="Schließen"
            >
              <X size={18} />
            </button>
          </div>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mt-4">
            <button
              onClick={handleAccept}
              className="px-6 py-2.5 rounded-full text-sm font-semibold text-white transition-all duration-300 hover:scale-105"
              style={{
                background: "oklch(0.52 0.09 128)",
                fontFamily: "var(--font-body)",
              }}
            >
              Alle akzeptieren
            </button>
            <button
              onClick={handleDecline}
              className="px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-105 border"
              style={{
                color: "oklch(0.75 0.01 80)",
                borderColor: "oklch(0.35 0.02 280)",
                background: "transparent",
                fontFamily: "var(--font-body)",
              }}
            >
              Nur notwendige
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
